import { getI18nText } from './i18nService'

export function getTechnicalDetails(data, technicalDetailsMicrocopy) {
  let technicalDetails = {}
  if (technicalDetailsMicrocopy) {
    Object.keys(technicalDetailsMicrocopy).forEach((item) => {
      switch (item) {
        case 'technicaldetails.actuation':
          if (data.actuation) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.actuation'),
              data.actuation
            )
          }
          break
        case 'technicaldetails.eu_country_of_origin':
          if (data.eu_country_of_origin) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.eu_country_of_origin'),
              data.eu_country_of_origin
            )
          }
          break
        case 'technicaldetails.port_size':
          if (data.port_size && data.port_size[0]) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.port_size'),
              data.port_size
            )
          }
          break
        case 'technicaldetails.gauge':
          if (data.gauge) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.gauge'),
              data.gauge
            )
          }
          break
        case 'technicaldetails.drain_type':
          if (data.drain_type) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.drain_type'),
              data.drain_type
            )
          }
          break
        case 'technicaldetails.cylinder_diameter_metric_length_millimetre':
          if (data.cylinder_diameter_metric_length_millimetre) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.cylinder_diameter_metric_length_millimetre'
              ),
              data.cylinder_diameter_metric_length_millimetre
            )
          }
          break
        case 'technicaldetails.outputpressureadjustmentrangebar':
          if (data.outlet_pressure_adjustment_pressure_bar_min_to_max_range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.outputpressureadjustmentrangebar'
              ),
              data.outlet_pressure_adjustment_pressure_bar_min_to_max_range
            )
          }
          break
        case 'technicaldetails.relievingnonrelieving':
          if (data.relievingnonrelieving) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.relievingnonrelieving'),
              data.relievingnonrelieving
            )
          }
          break
        case 'technicaldetails.strokelengthmetriclengthmillimetre':
          if (data.ItemStrokeLengthMetricLengthMillimetre) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.strokelengthmetriclengthmillimetre'
              ),
              data.ItemStrokeLengthMetricLengthMillimetre
            )
          }
          break
        case 'technicaldetails.series':
          if (data.series) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.series'),
              data.series
            )
          }
          break
        case 'technicaldetails.medium':
          if (data.medium) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.medium'),
              data.medium
            )
          }
          break
        case 'technicaldetails.body':
          if (data.body && data.body[0]) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.body'),
              data.body[0]
            )
          }
          break
        case 'technicaldetails.od_tube_length_millimetre':
          if (data.od_tube_length_millimetre) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.od_tube_length_millimetre'),
              data.od_tube_length_millimetre
            )
          }
          break
        case 'technicaldetails.operating_temperature_temperature_celsius_min_to_max_range':
          if (data.operating_temperature_temperature_celsius_min_to_max_range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.operating_temperature_temperature_celsius_min_to_max_range'
              ),
              data.operating_temperature_temperature_celsius_min_to_max_range
            )
          }
          break
        case 'technicaldetails.standard':
          if (data.standard) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.standard'),
              data.standard
            )
          }
          break
        case 'technicaldetails.thread':
          if (data.thread) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.thread'),
              data.thread
            )
          }
          break
        case 'technicaldetails.operatingpressurerangebar':
          if (data.OperatingPressureRangeBar) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.operatingpressurerangebar'),
              data.OperatingPressureRangeBar
            )
          }
          break
        case 'technicaldetails.operation':
          if (data.operation) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.operation'),
              data.operation
            )
          }
          break
        case 'technicaldetails.cable_length_length_meter':
          if (data.cable_length_length_meter) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.cable_length_length_meter'),
              data.cable_length_length_meter
            )
          }
          break
        case 'technicaldetails.colour':
          if (data.colour) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.colour'),
              data.colour
            )
          }
          break
        case 'technicaldetails.shape':
          if (data.shape) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.shape'),
              data.shape
            )
          }

          break
        case 'technicaldetails.fog_type':
          if (data.fog_type) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.fog_type'),
              data.fog_type
            )
          }
          break
        case 'technicaldetails.gauge_port':
          if (data.gauge_port) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.gauge_port'),
              data.gauge_port
            )
          }
          break

        case 'technicaldetails.bowl':
          if (data.bowl) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.bowl'),
              data.bowl
            )
          }
          break
        case 'technicaldetails.adjusting_knob':
          if (data.adjusting_knob) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.adjusting_knob'),
              data.adjusting_knob
            )
          }
          break
        case 'technicaldetails.bearings':
          if (data.bearings) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.bearings'),
              data.bearings
            )
          }
          break
        case 'technicaldetails.bonnet':
          if (data.bonnet) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.bonnet'),
              data.bonnet
            )
          }
          break
        case 'technicaldetails.buffer':
          if (data.buffer) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.buffer'),
              data.buffer
            )
          }
          break

        case 'technicaldetails.elastomers':
          if (data.elastomers) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.elastomers'),
              data.elastomers
            )
          }
          break
        case 'technicaldetails.filter_element':
          if (data.filter_element) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.filter_element'),
              data.filter_element
            )
          }
          break
        case 'technicaldetails.nuts_and_screws':
          if (data.nuts_and_screws) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.nuts_and_screws'),
              data.nuts_and_screws
            )
          }
          break
        case 'technicaldetails.piston_head_seals':
          if (data.piston_head_seals) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.piston_head_seals'),
              data.piston_head_seals
            )
          }
          break
        case 'technicaldetails.piston_rod_material':
          if (data.piston_rod_material) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.piston_rod_material'),
              data.piston_rod_material
            )
          }
          break
        case 'technicaldetails.piston':
          if (data.piston) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.piston'),
              data.piston
            )
          }
          break
        case 'technicaldetails.seals':
          if (data.seals) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.seals'),
              data.seals
            )
          }
          break
        case 'technicaldetails.seat_seal':
          if (data.seat_seal) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.seat_seal'),
              data.seat_seal
            )
          }
          break
        case 'technicaldetails.seats':
          if (data.seats) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.seats'),
              data.seats
            )
          }
          break
        case 'technicaldetails.shim_ring':
          if (data.shim_ring) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.shim_ring'),
              data.shim_ring
            )
          }
          break
        case 'technicaldetails.spool_sleeve':
          if (data.spool_sleeve) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.spool_sleeve'),
              data.spool_sleeve
            )
          }
          break
        case 'technicaldetails.certification__atex':
          if (data.certification__atex) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.certification__atex'),
              data.certification__atex
            )
          }
          break
        case 'technicaldetails.certification__ccc':
          if (data.certification__ccc) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.certification__ccc'),
              data.certification__ccc
            )
          }
          break
        case 'technicaldetails.certification__csa':
          if (data.certification__csa) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.certification__csa'),
              data.certification__csa
            )
          }
          break
        case 'technicaldetails.certification__emc':
          if (data.certification__emc) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.certification__emc'),
              data.certification__emc
            )
          }
          break
        case 'technicaldetails.certification__ip_rating':
          if (data.certification__ip_rating) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.certification__ip_rating'),
              data.certification__ip_rating
            )
          }
          break
        case 'technicaldetails.certification__reach':
          if (data.certification__reach) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.certification__reach'),
              data.certification__reach
            )
          }
          break
        case 'technicaldetails.certification__rohs_compliant':
          if (data.certification__rohs_compliant) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.certification__rohs_compliant'
              ),
              data.certification__rohs_compliant
            )
          }
          break
        case 'technicaldetails.certification__ul':
          if (data.certification__ul) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.certification__ul'),
              data.certification__ul
            )
          }
          break
        case 'technicaldetails.certification__weee':
          if (data.certification__weee) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.certification__weee'),
              data.certification__weee
            )
          }
          break
        case 'technicaldetails.eclass_11':
          if (data.eclass_11) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.eclass_11'),
              data.eclass_11
            )
          }
          break
        case 'technicaldetails.hs_code':
          if (data.hs_code) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.hs_code'),
              data.hs_code
            )
          }
          break
        case 'technicaldetails.hts_code':
          if (data.hts_code) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.hts_code'),
              data.hts_code
            )
          }
          break
        case 'technicaldetails.mil_spec':
          if (data.mil_spec) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.mil_spec'),
              data.mil_spec
            )
          }
          break
        case 'technicaldetails.unspsc_code':
          if (data.unspsc_code) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.unspsc_code'),
              data.unspsc_code
            )
          }
          break
        case 'technicaldetails.us_eccn':
          if (data.us_eccn) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.us_eccn'),
              data.us_eccn
            )
          }
          break
        case 'technicaldetails.range':
          if (data.range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.range'),
              data.range
            )
          }
          break
        case 'technicaldetails.filter_element_m_particlesize_micron':
          if (data.filter_element_m_particlesize_micron) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.filter_element_m_particlesize_micron'
              ),
              data.filter_element_m_particlesize_micron
            )
          }
          break
        case 'technicaldetails.maximum_inlet_pressure_pressure_bar':
          if (data.maximum_inlet_pressure_pressure_bar) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.maximum_inlet_pressure_pressure_bar'
              ),
              data.maximum_inlet_pressure_pressure_bar
            )
          }
          break
        case 'technicaldetails.outlet_pressure_adjustment_pressure_bar_min_to_max_range':
          if (data.outlet_pressure_adjustment_pressure_bar_min_to_max_range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.outlet_pressure_adjustment_pressure_bar_min_to_max_range'
              ),
              data.outlet_pressure_adjustment_pressure_bar_min_to_max_range
            )
          }
          break
        case 'technicaldetails.packing_and_supply_product_height_length_millimetre':
          if (data.packing_and_supply_product_height_length_millimetre) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.packing_and_supply_product_height_length_millimetre'
              ),
              data.packing_and_supply_product_height_length_millimetre
            )
          }
          break
        case 'technicaldetails.packing_and_supply_product_length_length_millimetre':
          if (data.packing_and_supply_product_length_length_millimetre) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.packing_and_supply_product_length_length_millimetre'
              ),
              data.packing_and_supply_product_length_length_millimetre
            )
          }
          break
        case 'technicaldetails.packing_and_supply_product_width_length_millimetre':
          if (data.packing_and_supply_product_width_length_millimetre) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.packing_and_supply_product_width_length_millimetre'
              ),
              data.packing_and_supply_product_width_length_millimetre
            )
          }
          break
        case 'technicaldetails.stroke_length_metric_length_millimetre':
          if (data.stroke_length_metric_length_millimetre) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.stroke_length_metric_length_millimetre'
              ),
              data.stroke_length_metric_length_millimetre
            )
          }
          break
        case 'technicaldetails.length_length_meter':
          if (data.length_length_meter) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.length_length_meter'),
              data.length_length_meter
            )
          }
          break
        case 'technicaldetails.operating_pressure_pressure_bar_min_to_max_range':
          if (data.operating_pressure_pressure_bar_min_to_max_range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.operating_pressure_pressure_bar_min_to_max_range'
              ),
              data.operating_pressure_pressure_bar_min_to_max_range
            )
          }
          break
        case 'technicaldetails.effective_weight_range_mass_kilogram_min_to_max_range':
          if (data.effective_weight_range_mass_kilogram_min_to_max_range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.effective_weight_range_mass_kilogram_min_to_max_range'
              ),
              data.effective_weight_range_mass_kilogram_min_to_max_range
            )
          }
          break
        case 'technicaldetails.coil_code':
          if (data.coil_code) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.coil_code'),
              data.coil_code
            )
          }
          break
        case 'technicaldetails.diameter_length_millimetre':
          if (data.diameter_length_millimetre) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.diameter_length_millimetre'),
              data.diameter_length_millimetre
            )
          }
          break
        case 'technicaldetails.female_thread':
          if (data.female_thread) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.female_thread'),
              data.female_thread
            )
          }
          break
        case 'technicaldetails.function':
          if (data.function) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.function'),
              data.function
            )
          }
          break
        case 'technicaldetails.hose_bore':
          if (data.hose_bore) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.hose_bore'),
              data.hose_bore
            )
          }
          break
        case 'technicaldetails.induced_air_vacuum_nlmin':
          if (data.induced_air_vacuum_nlmin) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.induced_air_vacuum_nlmin'),
              data.induced_air_vacuum_nlmin
            )
          }
          break
        case 'technicaldetails.iso_size':
          if (data.iso_size) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.iso_size'),
              data.iso_size
            )
          }
          break
        case 'technicaldetails.nominal_diameter':
          if (data.nominal_diameter) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.nominal_diameter'),
              data.nominal_diameter
            )
          }
          break
        case 'technicaldetails.nominal_diameter_length_millimetre':
          if (data.nominal_diameter_length_millimetre) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.nominal_diameter_length_millimetre'
              ),
              data.nominal_diameter_length_millimetre
            )
          }
          break
        case 'technicaldetails.number_of_convolutions':
          if (data.number_of_convolutions) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.number_of_convolutions'),
              data.number_of_convolutions
            )
          }
          break
        case 'technicaldetails.id_tube_metric_length_millimetre':
          if (data.id_tube_metric_length_millimetre) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.id_tube_metric_length_millimetre'
              ),
              data.id_tube_metric_length_millimetre
            )
          }
          break
        case 'technicaldetails.minimum_bend_radius_length_millimetre':
          if (data.minimum_bend_radius_length_millimetre) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.minimum_bend_radius_length_millimetre'
              ),
              data.minimum_bend_radius_length_millimetre
            )
          }
          break
        case 'technicaldetails.packing_and_supply_product_weight_weight_kilogram':
          if (data.packing_and_supply_product_weight_weight_kilogram) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.packing_and_supply_product_weight_weight_kilogram'
              ),
              data.packing_and_supply_product_weight_weight_kilogram
            )
          }
          break
        case 'technicaldetails.brand':
          if (data.brand) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.brand'),
              data.brand
            )
          }
          break
        case 'technicaldetails.data_performance_b10_value_number_of_cycles':
          if (data.data_performance_b10_value_number_of_cycles) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.data_performance_b10_value_number_of_cycles'
              ),
              data.data_performance_b10_value_number_of_cycles
            )
          }
          break
        case 'technicaldetails.data_performance_shelf_life':
          if (data.data_performance_shelf_life) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.data_performance_shelf_life'
              ),
              data.data_performance_shelf_life
            )
          }
          break
        case 'technicaldetails.control_signal':
          if (data.control_signal) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.control_signal'),
              data.control_signal
            )
          }
          break

        case 'technicaldetails.cushioning':
          if (data.cushioning) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.cushioning'),
              data.cushioning
            )
          }
          break
        case 'technicaldetails.cv_body_flowcoefficient_cv':
          if (data.cv_body_flowcoefficient_cv) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.cv_body_flowcoefficient_cv'),
              data.cv_body_flowcoefficient_cv
            )
          }
          break
        case 'technicaldetails.flow_imperial_flow_scfm':
          if (data.flow_imperial_flow_scfm) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.flow_imperial_flow_scfm'),
              data.flow_imperial_flow_scfm
            )
          }
          break
        case 'technicaldetails.fluid_temperature_imperial_temperature_fahrenheit_min_to_max_range':
          if (data.fluid_temperature_imperial_temperature_fahrenheit_min_to_max_range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.fluid_temperature_imperial_temperature_fahrenheit_min_to_max_range'
              ),
              data.fluid_temperature_imperial_temperature_fahrenheit_min_to_max_range
            )
          }
          break

        case 'technicaldetails.guiding_system':
          if (data.guiding_system) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.guiding_system'),
              data.guiding_system
            )
          }
          break
        case 'technicaldetails.iforwardslashd_tube':
          if (data.iforwardslashd_tube) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.iforwardslashd_tube'),
              data.iforwardslashd_tube
            )
          }
          break
        case 'technicaldetails.maximum_flow_flow_scfm':
          if (data.maximum_flow_flow_scfm) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.maximum_flow_flow_scfm'),
              data.maximum_flow_flow_scfm
            )
          }
          break
        case 'technicaldetails.non_magnetic_or_magnetic':
          if (data.non_magnetic_or_magnetic) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.non_magnetic_or_magnetic'),
              data.non_magnetic_or_magnetic
            )
          }
          break
        case 'technicaldetails.oforwardslashd_tube_inch':
          if (data.oforwardslashd_tube_inch) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.oforwardslashd_tube_inch'),
              data.oforwardslashd_tube_inch
            )
          }
          break
        case 'technicaldetails.operating_pressure_psi_pressure_psi_min_to_max_range':
          if (data.operating_pressure_psi_pressure_psi_min_to_max_range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.operating_pressure_psi_pressure_psi_min_to_max_range'
              ),
              data.operating_pressure_psi_pressure_psi_min_to_max_range
            )
          }
          break
        case 'technicaldetails.operating_temperature_f_temperature_fahrenheit_min_to_max_range':
          if (data.operating_temperature_f_temperature_fahrenheit_min_to_max_range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.operating_temperature_f_temperature_fahrenheit_min_to_max_range'
              ),
              data.operating_temperature_f_temperature_fahrenheit_min_to_max_range
            )
          }
          break

        case 'technicaldetails.outlet_pressure_adjustment_imperial_pressure_psig_min_to_max_range':
          if (data.outlet_pressure_adjustment_imperial_pressure_psig_min_to_max_range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.outlet_pressure_adjustment_imperial_pressure_psig_min_to_max_range'
              ),
              data.outlet_pressure_adjustment_imperial_pressure_psig_min_to_max_range
            )
          }
          break
        case 'technicaldetails.scale_bar_pressure_bar_min_to_max_range':
          if (data.scale_bar_pressure_bar_min_to_max_range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.scale_bar_pressure_bar_min_to_max_range'
              ),
              data.scale_bar_pressure_bar_min_to_max_range
            )
          }
          break
        case 'technicaldetails.scale_mpa_pressure_mpa_min_to_max_range':
          if (data.scale_mpa_pressure_mpa_min_to_max_range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.scale_mpa_pressure_mpa_min_to_max_range'
              ),
              data.scale_mpa_pressure_mpa_min_to_max_range
            )
          }
          break
        case 'technicaldetails.scale_psi_pressure_psi_min_to_max_range':
          if (data.scale_psi_pressure_psi_min_to_max_range) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.scale_psi_pressure_psi_min_to_max_range'
              ),
              data.scale_psi_pressure_psi_min_to_max_range
            )
          }
          break
        case 'technicaldetails.stroke_length_inch':
          if (data.stroke_length_inch) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.stroke_length_inch'),
              data.stroke_length_inch
            )
          }
          break
        case 'technicaldetails.theoretical_force_force_newton':
          if (data.theoretical_force_force_newton) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.theoretical_force_force_newton'
              ),
              data.theoretical_force_force_newton
            )
          }
          break
        case 'technicaldetails.barrel':
          if (data.barrel) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.barrel'),
              data.barrel
            )
          }
          break
        case 'technicaldetails.cylinder_diameter_inch':
          if (data.cylinder_diameter_inch) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.cylinder_diameter_inch'),
              data.cylinder_diameter_inch
            )
          }
          break
        case 'technicaldetails.valve_operation':
          if (data.valve_operation) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.valve_operation'),
              data.valve_operation
            )
          }
          break
        case 'technicaldetails.adjustment':
          if (data.adjustment) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.adjustment'),
              data.adjustment
            )
          }
          break
        case 'technicaldetails.rotation_angle':
          if (data.rotation_angle) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.rotation_angle'),
              data.rotation_angle
            )
          }
          break
        case 'technicaldetails.flow_flow_dm3sec':
          if (data.flow_flow_dm3sec) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.flow_flow_dm3sec'),
              data.flow_flow_dm3sec
            )
          }
          break
        case 'technicaldetails.flow_flow_litresperminute':
          if (data.flow_flow_litresperminute) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.flow_flow_litresperminute'),
              data.flow_flow_litresperminute
            )
          }
          break
        case 'technicaldetails.start_point_flow_dm3sec':
          if (data.start_point_flow_dm3sec) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.start_point_flow_dm3sec'),
              data.start_point_flow_dm3sec
            )
          }
          break

        case 'technicaldetails.od_tube_inch':
          if (data.od_tube_inch) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(technicalDetailsMicrocopy, 'technicaldetails.od_tube_inch'),
              data.od_tube_inch
            )
          }
          break
        case 'technicaldetails.maximum_inlet_pressure_imperial_pressure_psi':
          if (data.maximum_inlet_pressure_imperial_pressure_psi) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.maximum_inlet_pressure_imperial_pressure_psi'
              ),
              data.maximum_inlet_pressure_imperial_pressure_psi
            )
          }
          break
        case 'technicaldetails.start_point_imperial_flow_scfm':
          console.log(data.start_point_imperial_flow_scfm)
          if (data.start_point_imperial_flow_scfm) {
            setTechnicalDetailValue(
              technicalDetails,
              getI18nText(
                technicalDetailsMicrocopy,
                'technicaldetails.start_point_imperial_flow_scfm'
              ),
              data.start_point_imperial_flow_scfm
            )
          }
          break

        default:
          break
      }
    })
  }

  return technicalDetails
}

export function getPriorityTechnicalDetails(data, priorityTechnicalDetailsMicrocopy) {
  let priorityTechnicalDetails = {}

  if (priorityTechnicalDetailsMicrocopy) {
    Object.keys(priorityTechnicalDetailsMicrocopy).forEach((item) => {
      switch (item) {
        case 'prioritytechnicaldetails.actuation':
          if (data.actuation) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.actuation'),
              data.actuation
            )
          }
          break
        case 'prioritytechnicaldetails.port_size':
          if (data.port_size && data.port_size[0]) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.port_size'),
              data.port_size[0]
            )
          }
          break
        case 'prioritytechnicaldetails.gauge':
          if (data.gauge) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.gauge'),
              data.gauge
            )
          }
          break
        case 'prioritytechnicaldetails.drain_type':
          if (data.drain_type) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.drain_type'),
              data.drain_type
            )
          }
          break
        case 'prioritytechnicaldetails.cylinder_diameter_metric_length_millimetre':
          if (data.cylinder_diameter_metric_length_millimetre) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.cylinder_diameter_metric_length_millimetre'
              ),
              data.cylinder_diameter_metric_length_millimetre
            )
          }
          break
        case 'prioritytechnicaldetails.outlet_pressure_adjustment_pressure_bar_min_to_max_range':
          if (data.outlet_pressure_adjustment_pressure_bar_min_to_max_range) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.outlet_pressure_adjustment_pressure_bar_min_to_max_range'
              ),
              data.outlet_pressure_adjustment_pressure_bar_min_to_max_range
            )
          }
          break
        case 'prioritytechnicaldetails.relievingnonrelieving':
          if (data.relievingnonrelieving) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.relievingnonrelieving'
              ),
              data.relievingnonrelieving
            )
          }
          break
        case 'prioritytechnicaldetails.strokelengthmetriclengthmillimetre':
          if (data.ItemStrokeLengthMetricLengthMillimetre) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.strokelengthmetriclengthmillimetre'
              ),
              data.ItemStrokeLengthMetricLengthMillimetre
            )
          }
          break
        case 'prioritytechnicaldetails.cylinder_diameter_inch':
          if (data.cylinder_diameter_inch) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.cylinder_diameter_inch'
              ),
              data.cylinder_diameter_inch
            )
          }
          break
        case 'prioritytechnicaldetails.series':
          if (data.series) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.series'),
              data.series
            )
          }
          break
        case 'prioritytechnicaldetails.medium':
          if (data.medium) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.medium'),
              data.medium
            )
          }
          break
        case 'prioritytechnicaldetails.body':
          if (data.body) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.body'),
              data.body
            )
          }
          break
        case 'prioritytechnicaldetails.od_tube_length_millimetre':
          if (data.od_tube_length_millimetre) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.od_tube_length_millimetre'
              ),
              data.od_tube_length_millimetre
            )
          }
          break
        case 'prioritytechnicaldetails.operating_temperature_temperature_celsius_min_to_max_range':
          if (data.operating_temperature_temperature_celsius_min_to_max_range) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.operating_temperature_temperature_celsius_min_to_max_range'
              ),
              data.operating_temperature_temperature_celsius_min_to_max_range
            )
          }
          break
        case 'prioritytechnicaldetails.standard':
          if (data.standard) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.standard'),
              data.standard
            )
          }
          break
        case 'prioritytechnicaldetails.thread':
          if (data.thread) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.thread'),
              data.thread
            )
          }
          break
        case 'prioritytechnicaldetails.operating_pressure_pressure_bar_min_to_max_range':
          if (data.operating_pressure_pressure_bar_min_to_max_range) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.operating_pressure_pressure_bar_min_to_max_range'
              ),
              data.operating_pressure_pressure_bar_min_to_max_range
            )
          }
          break

        case 'prioritytechnicaldetails.operation':
          if (data.operation) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.operation'),
              data.operation
            )
          }
          break
        case 'prioritytechnicaldetails.cable_length_length_meter':
          if (data.cable_length_length_meter) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.cable_length_length_meter'
              ),
              data.cable_length_length_meter
            )
          }
          break
        case 'prioritytechnicaldetails.colour':
          if (data.colour) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.cable_length_length_meter'
              ),
              data.cable_length_length_meter
            )
            priorityTechnicalDetails[
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.colour')
            ] = data.colour
          }
          break
        case 'prioritytechnicaldetails.shape':
          if (data.ItemShape) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.shape'),
              data.shape
            )
          }
          break
        case 'prioritytechnicaldetails.itemlengthlengthmeter':
          if (data.ItemLengthLengthMeter) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.itemlengthlengthmeter'
              ),
              data.ItemLengthLengthMeter
            )
          }
          break
        case 'prioritytechnicaldetails.bowl':
          if (data.bowl) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(priorityTechnicalDetailsMicrocopy, 'prioritytechnicaldetails.bowl'),
              data.bowl
            )
          }
          break
        case 'prioritytechnicaldetails.stroke_length_metric_length_millimetre':
          if (data.stroke_length_metric_length_millimetre) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.stroke_length_metric_length_millimetre'
              ),
              data.stroke_length_metric_length_millimetre
            )
          }
          break
        case 'prioritytechnicaldetails.length_length_meter':
          if (data.length_length_meter) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.length_length_meter'
              ),
              data.length_length_meter
            )
          }
          break

        case 'prioritytechnicaldetails.stroke_length_inch':
          if (data.stroke_length_inch) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.stroke_length_inch'
              ),
              data.stroke_length_inch
            )
          }
          break
        case 'prioritytechnicaldetails.od_tube_inch':
          if (data.od_tube_inch) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.od_tube_inch'
              ),
              data.od_tube_inch
            )
          }
          break
        case 'prioritytechnicaldetails.outlet_pressure_adjustment_imperial_pressure_psig_min_to_max_range':
          if (data.outlet_pressure_adjustment_imperial_pressure_psig_min_to_max_range) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.outlet_pressure_adjustment_imperial_pressure_psig_min_to_max_range'
              ),
              data.outlet_pressure_adjustment_imperial_pressure_psig_min_to_max_range
            )
          }
          break
        case 'prioritytechnicaldetails.valve_operation':
          if (data.valve_operation) {
            setTechnicalDetailValue(
              priorityTechnicalDetails,
              getI18nText(
                priorityTechnicalDetailsMicrocopy,
                'prioritytechnicaldetails.valve_operation'
              ),
              data.valve_operation
            )
          }
          break

        default:
          break
      }
    })
  }

  return priorityTechnicalDetails
}

function setTechnicalDetailValue(technicalDetails, key, value) {
  if (technicalDetails[key] !== undefined) {
    let previousValue = technicalDetails[key]
    technicalDetails[key] = `${previousValue}, ${value}`
  } else {
    technicalDetails[key] = value
  }
}
